<sm-dialog-template iconClass="al-ico-access-key" header="S3 credentials" (xClicked)="xClicked()" [header]="isAzure? 'Azure credentials': 'S3 credentials'">
  <sm-s3-access-dialog
    [header]="header"
    [bucket]="bucket"
    [endpoint]="endpoint"
    [region]="region"
    [secret]="secret"
    [key]="key"
    [token]="token"
    [editMode]="editMode"
    [isAzure]="isAzure"
    (closeSave)="saveS3Credentials($event)"
    (closeCancel)="cancelClicked()">
  </sm-s3-access-dialog>
</sm-dialog-template>
